import { render, staticRenderFns } from "./SurnameTest.vue?vue&type=template&id=b23dff32&scoped=true&"
import script from "./SurnameTest.vue?vue&type=script&lang=js&"
export * from "./SurnameTest.vue?vue&type=script&lang=js&"
import style0 from "./SurnameTest.vue?vue&type=style&index=0&id=b23dff32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23dff32",
  null
  
)

export default component.exports